<pbc-sorter [config]="ObjektArtsSorterConfig" [sorter]="objektArts.sorter$ | async" (sorterChange)="objektArts.sorter$.next($event)"></pbc-sorter>
